




























































































































































































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Lot, ApiError, Media, User } from '@/api';
import { snackModule, auctionModule, authModule } from '@/store';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly lots: Lot[];
  @Prop({ required: false }) readonly selectedLot: Lot;
  @Prop({ required: false }) readonly isCurrent: boolean;
  @Prop({ required: false, default: true }) readonly showArrows: boolean;
  @Prop({ required: false, type: Boolean, default: false })
  readonly showShare: boolean;

  lot: Lot | null = null;
  currentSlide: number = 0;

  copyMessage: string = 'Copy URL';

  setSlide(index: number) {
    this.currentSlide = index;
  }

  openImage(url: string) {
    if (!url) {
      return;
    }
    window.open(url, '_blank');
  }

  copyUrl(e: Event) {
    const input = document.createElement('input');
    const text = window.location.href;
    const container = document.getElementsByClassName('copy-url');

    container[0].appendChild(input);
    input.value = text;
    input.select();

    try {
      const successful = document.execCommand('copy');
      this.copyMessage = 'Copied!';
    } catch (err) {
      // Error
    } finally {
      container[0].removeChild(input);
      setTimeout(() => (this.copyMessage = 'Copy URL'), 3000);
    }
  }

  wishIcon() {
    if (
      !authModule.user ||
      !this.selectedLot.id ||
      !this.selectedLot.auction.id
    ) {
      return;
    }
    const wish =
      auctionModule.wishes[this.selectedLot.auction.id][this.selectedLot.id];
    if (wish) {
      return true;
    } else {
      return false;
    }
  }

  addBid() {
    this.$emit('add-bid', this.selectedLot);
  }

  toggleWish() {
    this.$emit('toggle-wish', this.selectedLot);
  }

  prevLot() {
    this.$emit('prev-lot');
  }

  nextLot() {
    this.$emit('next-lot');
  }

  close() {
    this.$emit('close-lot');
  }
}
